import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
import { buildCampaignListQuery, buildCampaignLogsQuery } from './CampaignQuery.services.helper';

const GetCampaignList = (params: any) => {
    const parameters = buildCampaignListQuery(params);

    return request({
        url: `${ApiURL.Query.CampaignList}?${parameters}`,
        method: RequestType.GET,
        //  params:params,
    });
};

const GetMatrixList = (params: any) => {
    let parameters = '';
    if (params['regionId'] != undefined) {
        // parameters += parameters.length > 0 ? "&" : "";
        parameters += `RegionId=${params['regionId']}`;
    }

    return request({
        url: `${ApiURL.Query.MatrixList}?${parameters}`,
        method: RequestType.GET,
        //  params:params,
    });
};

const GetAssigneeList = (params: any) => {
    let parameters = '';
    if (params['regionId'] != undefined) {
        // parameters += parameters.length > 0 ? "&" : "";
        parameters += `RegionId=${params['regionId']}`;
    }

    return request({
        url: `${ApiURL.Query.AssigneeList}?${parameters}`,
        method: RequestType.GET,
        //  params:params,
    });
};

const GetCampaign = (params: any) => {
    let parameters = '';
    if (params['Id'] != undefined) {
        parameters += `Id=${params['Id']}`;
    }

    if (params['regionId'] != undefined) {
        parameters += parameters.length > 0 ? '&' : '';
        parameters += `RegionId=${params['regionId']}`;
    }

    return request({
        url: `${ApiURL.Query.Campaign}?${parameters}`,
        method: RequestType.GET,
    });
};

const GetBadges = (params: any) => {
    let parameters = '';

    if (params['regionId'] != undefined) {
        parameters += parameters.length > 0 ? '&' : '';
        parameters += `RegionId=${params['regionId']}`;
    }

    return request({
        url: `${ApiURL.Query.BadgeAssetList}?${parameters}`,
        method: RequestType.GET,
    });
};

const GetCoupons = (params: any) => {
    let parameters = '';
    if (params['Id'] != undefined) {
        parameters += `Id=${params['Id']}`;
    }

    if (params['culture'] != undefined) {
        parameters += parameters.length > 0 ? '&' : '';
        parameters += `culture=${params['culture']}`;
    }

    return request({
        url: `${ApiURL.Query.CouponList}?${parameters}`,
        method: RequestType.GET,
    });
};

const GetMetaData = (params: any) => {
    let parameters = '';
    if (params['campaignRuleId'] != undefined) {
        parameters += `CampaignRuleId=${params['campaignRuleId']}`;
    }

    return request({
        url: `${ApiURL.Query.Metadata}?${parameters}`,
        method: RequestType.GET,
    });
};

const GetRulesByCampaignRuleId = (params: any) => {
    let parameters = '';
    if (params['campaignRuleId'] != undefined) {
        parameters += `CampaignRuleId=${params['campaignRuleId']}`;
    }

    if (params['culture'] != undefined) {
        parameters += parameters.length > 0 ? '&' : '';
        parameters += `culture=${params['culture']}`;
    }

    return request({
        url: `${ApiURL.Query.GetRulesByCampaignRuleId}?${parameters}`,
        method: RequestType.GET,
    });
};

const DeleteRuleById = (params: any) => {
    let parameters = '';
    if (params['Id'] != undefined) {
        parameters += `Id=${params['Id']}`;
    }

    return request({
        url: `${ApiURL.Query.DeleteRuleById}?${parameters}`,
        method: RequestType.GET,
    });
};

const DeleteRuleConditionById = (params: any) => {
    let parameters = '';
    if (params['Id'] != undefined) {
        parameters += `Id=${params['Id']}`;
    }

    return request({
        url: `${ApiURL.Query.DeleteRuleConditionById}?${parameters}`,
        method: RequestType.GET,
    });
};

const GetEarningsByCampaignRuleId = (params: any) => {
    let parameters = '';
    if (params['campaignRuleId'] != undefined) {
        parameters += `CampaignRuleId=${params['campaignRuleId']}`;
    }

    return request({
        url: `${ApiURL.Query.GetEarningsByCampaignRuleId}?${parameters}`,
        method: RequestType.GET,
    });
};

const GetEarningById = (params: any) => {
    let parameters = '';
    if (params['Id'] != undefined) {
        parameters += `Id=${params['Id']}`;
    }

    return request({
        url: `${ApiURL.Query.GetEarningById}?${parameters}`,
        method: RequestType.GET,
    });
};

const DeleteEarningById = (params: any) => {
    let parameters = '';
    if (params['Id'] != undefined) {
        parameters += `Id=${params['Id']}`;
    }

    return request({
        url: `${ApiURL.Query.DeleteEarningById}?${parameters}`,
        method: RequestType.GET,
    });
};

const GetLogs = (params: any) => {
    const parameters = buildCampaignLogsQuery(params);

    return request({
        url: `${ApiURL.Query.GetLogs}?${parameters}`,
        method: RequestType.GET,
    });
};

const GetAISuggestion = (data: { campaignRule: number }): Promise<any> =>
    request({
        url: ApiURL.Query.GetAISuggestion,
        method: RequestType.GET,
        params: data,
    });

const CampaignManagementQuery = {
    GetCampaignList,
    GetMatrixList,
    GetAssigneeList,
    GetCampaign,
    GetBadges,
    GetCoupons,
    GetAISuggestion,
    GetMetaData,
    GetRulesByCampaignRuleId,
    DeleteRuleById,
    DeleteRuleConditionById,
    GetEarningsByCampaignRuleId,
    GetEarningById,
    DeleteEarningById,
    GetLogs,
};

export default CampaignManagementQuery;
